// extracted by mini-css-extract-plugin
module.exports = {"innholdssideMedMeny":"InnholdssideMedMeny_innholdssideMedMeny__lhuWs","pullUp":"InnholdssideMedMeny_pullUp__gfFc7","mainContent":"InnholdssideMedMeny_mainContent__h3Zdl"};